import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import HrbTranslate from "../language/HrbTranslate";
import Lang from "../language/services/Lang";
import { connect } from 'react-redux';
import { getLanguage } from '../../store/rootReducer';
import './ExternalLink.scss';

class ExternalLink extends Component {

  getPopupConditions() {
    let attributes = {};

    if (this.props.isNewWindow) {
      attributes.rel = "noopener noreferrer";
      attributes.target = "_blank";
    }

    return attributes;
  }

  getLink() {
    return Lang.getValue(this.props.linkKey, this.props.language);
  }

  render() {
    return (
        <a className="hrb-link hrb-external-link" href={this.getLink()} {...this.getPopupConditions()}>
          {this.props.textKey && <HrbTranslate text={this.props.textKey}/>}
          {this.props.children}
        </a>
    )
  }
}

ExternalLink.propTypes = {
  linkKey: PropTypes.string,
  textKey: PropTypes.string,
  isNewWindow: PropTypes.bool
};

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  }
};

export default connect(
    mapStateToProps
)(ExternalLink);